import { ReactNode } from 'react';
import Paper, { PaperProps } from '@mui/material/Paper';

interface BasePaperProps extends PaperProps {
    children: ReactNode;
    isFullHeight?: boolean;
}

function BasePaper({ children, isFullHeight = true, ...props }: BasePaperProps) {
    return (
        <Paper
            {...props}
            sx={{
                ...props.sx,
                px: { xs: 1.5, md: 2, lg: 6 },
                py: { xs: 0.8, md: 1, lg: 1 },
                m: 0,
                mb: isFullHeight ? 0 : 1,
                minHeight: isFullHeight ? 'calc(100vh - 70px)' : 'auto', // 70px = header height + main padding-top + main padding-bottom
            }}
        >
            {children}
        </Paper>
    );
}

export default BasePaper;
